import PasswordResetModal from './PasswordResetModal';

export default PasswordResetModal;
